import React, {useEffect} from "react";
import {connect} from "react-redux";

import AddButton from "../PricingComponents/AddButton";
import PricingSection from "../PricingComponents/PricingSection";
import {getFilteredFeatures} from "../../FeaturesSetup/featuresFunctions";
import {loadPresets} from "../../../actions/pricingPresets";


const PricingPriceGroups = (props) => {

  const {presets, presetsReceived, featuresList, loadPresets} = props;

  const onInputChange = () => {

  }

  useEffect(() => {
    loadPresets(false);
  }, []);

  return (
    <PricingSection text={"Price Groups"}
                    rightComponents={<AddButton text="Add Price Group"/>}
                    sectionId={"pricingGroups"}>
      {!presetsReceived ? <div className="ui-loader ui-loader--small"/> : (
        <div className="grid pr-grid pr-grid--groups">
          <div className="pr-grid-th font--12">
            <div className="pr-grid-cell flex flex--center pl-1 pr-1">Group</div>
            <div className="pr-grid-cell flex flex--center pl-1 pr-1">Price</div>
            <div className="pr-grid-cell flex flex--center pl-1 pr-1">Assigned Items</div>
            <div className="pr-grid-cell flex flex--center pl-1 pr-1"/>
          </div>
          {presets.map(preset => {
            const itemsCount = featuresList.filter(feature => {
              return feature.pricingProfileName && (feature.pricingProfileName === preset.name)
            }).length;
            return (
              <div className="pr-grid-row" key={preset.id}>
                <div className="pr-grid-cell font--12 color-green bold flex flex--center flex--start pl-1 pr-1">
                  {preset.name}
                </div>
                <div className="pr-grid-cell font--12 flex flex--center pl-1 pr-1">
                  <select
                    className="radius-5 ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr"
                    onChange={onInputChange}>
                    <option value="option1">Some Option Value</option>
                  </select>
                  <span className="font--12 ml-05 mr-05">$</span>
                  <input placeholder="" type="text"
                         className="radius-5 ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr"
                         onChange={onInputChange}
                         value=""/>
                  <span className="font--12 ml-05 bold">/SQFT</span>
                </div>
                <div className="pr-grid-cell flex flex--center flex--between pl-1 pr-1">
                  <span className="font--12 color-green bold">{itemsCount} Items</span>
                </div>
                <div className="pr-grid-cell flex flex--center flex--between pl-1 pr-1">
                  <button className="ui-close ui-close--gray2 ui-close--small"/>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </PricingSection>
  )
};

const mapStateToProps = (store) => {
  const {priceListActiveSortTab} = store.pricingState;
  const {presetsReceived, presets} = store.pricingPreset;
  const {featuresListReceived} = store.featuresSetupState;

  return {
    priceListActiveSortTab,
    presetsReceived,
    presets: presets || [],
    featuresList: featuresListReceived ? getFilteredFeatures(store) : [],
  };
};

const mapDispatchToProps = {
  loadPresets,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPriceGroups);
